module.exports = __webpack_public_path__ + "static/media/Red-Raspberry-Tower-768x668.5886b0b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/Red-Raspberry-Tower-768x668.png
// module id = 155
// module chunks = 0